<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h2 class="mb-0">
                        {{ $tc('message.cardiologyConsultations', 1) }}
                    </h2>
                </div>
            </div>

            <div class="card-body">
                <b-tabs
                        card
                        content-class="mt-3"
                        fill
                        active-nav-item-class="font-weight-bold text-uppercase text-success"

                >
                    <b-tab no-body :title="$t('message.infoConsultation')"
                    >
                        <b-row>
                            <b-col  col sm="8">
                                <div class="list-group">
                                    <b-row>
                                        <b-col col sm="12" class="mb-3">
                                            <div class="">
                                                <h4 class="consultation-item__title">{{ $t('message.institutionConsultation') }} </h4>
                                                <span class="font-weight-bold">
                                                    <p class="consultation-item__body"> {{ etablissement }} </p>
                                                </span>
                                            </div>
                                        </b-col>

                                        <b-col col sm="12" class="mb-3">
                                            <div class="">
                                                <h4 class="consultation-item__title"> {{ $tc('message.practitioners',1) }} </h4>
                                                <span class="font-weight-bold">
                                                    <p class="consultation-item__body"> {{ praticien }} </p>
                                                </span>
                                            </div>
                                        </b-col>

                                        <b-col col sm="12" class="mb-3">
                                            <div class="">
                                                <h4 class="consultation-item__title">{{ $t('message.consultationDate') }} </h4>


                                                <p class="consultation-item__body"> {{ formattedDate(mConsultation.date_consultation) }} </p>

                                            </div>
                                        </b-col>

                                        <b-col col sm="12" class="mb-3" v-if="contributeurs.length>0">
                                            <div class="">
                                                <h4 class="consultation-item__title"> {{ $tc('message.contributors',2) }} </h4>
                                                <span class="font-weight-bold" v-for="contributeur in contributeurs" :key="contributeur.nom">
                                                    <p class="consultation-item__body"> {{ contributeur.nom }} </p>
                                                </span>
                                            </div>
                                        </b-col>

                                        <b-col col sm="12" class="mb-3">
                                            <div class="">
                                                <h4 class="consultation-item__title"> {{ $tc('message.reasons', 1) }} </h4>
                                                <p class="consultation-item__body">{{ reasons }}</p>
                                            </div>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col col sm="12" class="mb-3">
                                            <div class="">
                                                <h4 class="consultation-item__title"> {{ $t('message.anamnesis') }} </h4>

                                                <p class="consultation-item__body" v-html="mConsultation.anamnese">  </p>

                                            </div>
                                        </b-col>
                                        <b-col col sm="12" class="mb-3">
                                            <div class="">
                                                <h4 class="consultation-item__title"> {{ $t('message.riskFactor') }} </h4>

                                                <p class="consultation-item__body" v-html="mConsultation.facteur_de_risque">  </p>

                                            </div>
                                        </b-col>
                                    </b-row>
                                    <!--//Antecedent-->
                                    <b-row>
                                        <b-col col sm="12" class="mb-3">

                                            <h4 class="consultation-item__title">{{ $tc('message.antecedents',2) }} </h4>

                                            <div  v-if="antecedentsRows">
                                                <div v-for="antecedents in antecedentsRows" :key="antecedents.slug">
                                                    <b-list-group>
                                                        <b-list-group-item v-for="antecedent in antecedents.children" :key="antecedent.id" class="d-flex justify-content-between align-items-center">
                                                            <b-badge variant="primary" pill class="consultation-item__body">{{antecedents.label}}</b-badge>
                                                            <p class="consultation-item__body">{{antecedent.description}} </p>
                                                        </b-list-group-item>
                                                    </b-list-group>
                                                </div>
                                            </div>

                                        </b-col>
                                    </b-row>
                                    <!--                                    //Allergies-->
                                    <b-row>
                                        <b-col col sm="12" class="mb-3">

                                            <h4 class="consultation-item__title"> {{ $tc('message.allergies',2) }} </h4>
                                            <!--<div class="font-weight-bold ml-3" v-if="allergiesRows">-->
                                            <div v-for="allergy in allergiesRows" :key="allergy.slug">
                                                <p class="consultation-item__body">{{allergy.description}}</p>
                                            </div>
                                            <!-- </div>-->

                                        </b-col>
                                    </b-row>
                                    <!--//Traitement actuel-->
<!--                                    <b-row>-->
<!--                                        <b-col col sm="12" class="mb-3">-->
<!--                                            <h4>{{ $t('message.currentTreatments') }} </h4>-->
<!--                                            <div class="ml-3" v-if="traitementsRows">-->
<!--                                                <div>-->
<!--                                                    <p> {{lastTraitment}}</p>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </b-col>-->
<!--                                    </b-row>-->
                                    <!--                                    //Mode de vie-->
                                    <b-row>
                                        <b-col col sm="12" class="mb-3">
                                            <h4 class="consultation-item__title"> {{ $t('message.lifestyle') }} </h4>
                                            <b-list-group>
                                                <b-list-group-item class="consultation-item__body"> {{ $t('message.profession') }} :  {{ mConsultation.profession }} </b-list-group-item>
                                                <b-list-group-item class="consultation-item__body"> {{ $t('message.familyStuation') }}  : {{ mConsultation.situation_familiale }} </b-list-group-item>
                                                <b-list-group-item class="consultation-item__body"> {{ $tc('message.enfants',2) }}  : {{ mConsultation.nbre_enfant }} </b-list-group-item>
                                                <b-list-group-item class="consultation-item__body"> {{ $t('message.tabac') }}  : {{ mConsultation.tabac }} UPA </b-list-group-item>
                                                <b-list-group-item class="consultation-item__body"> {{ $t('message.alcool') }}  :{{ mConsultation.alcool }} </b-list-group-item>
                                                <!--                                                <b-list-group-item> {{ $t('message.autres') }}  :{!! mConsultation.autres !!} </b-list-group-item>-->
                                            </b-list-group>
                                        </b-col>
                                    </b-row>
                                    <!--                                    //Examen clinique-->
                                    <b-row class="mb-3">
                                        <b-col col sm="12" class="mb-3">

                                            <h4 class="consultation-item__title">{{ $tc('message.physicalExams',1) }} </h4>


                                            <p v-html="mConsultation.examen_clinique">  </p>

                                        </b-col>
                                        <!--                                        <b-col col sm="12">-->
                                        <!--                                            <div class="">-->
                                        <!--                                                <h4>{{ $tc('message.complementaryExams',2) }} </h4>-->


                                        <!--                                                <p v-html="mConsultation.examen_complementaire"></p>-->

                                        <!--                                            </div>-->
                                        <!--                                        </b-col>-->
                                    </b-row>
                                    <!--Parametres-->
                                    <b-row>
                                        <b-col col sm="6" class="mb-3">
                                            <div class="">
                                                <h4 class="consultation-item__title">{{ $t('message.parameter') }}</h4>

                                                <div v-if="commonParametersRows">
                                                    <div class="ml-3" v-for="parameter in commonParametersRows" :key="parameter.slug">


                                                        <b-list-group>
                                                            <b-list-group-item class="consultation-item__body">  {{ $t('message.weight') }} :  {{ parameter.poids }} </b-list-group-item>
                                                            <b-list-group-item class="consultation-item__body"> {{ $t('message.height') }}  : {{ parameter.taille }} </b-list-group-item>
                                                            <b-list-group-item class="consultation-item__body">  {{ $t('message.bmi') }}  :  {{ parameter.bmi }} </b-list-group-item>
                                                            <b-list-group-item class="consultation-item__body"> {{ $t('message.abdoPerimetre') }}  : {{ parameter.perimetre_abdominal }} </b-list-group-item>
                                                            <b-list-group-item class="consultation-item__body"> {{ $t('message.taSystoliqueL') }} : {{ parameter.taSystoliqueL }} </b-list-group-item>
                                                            <b-list-group-item class="consultation-item__body"> {{ $t('message.taDiastoliqueL') }} :{{ parameter.taDiastoliqueL }} </b-list-group-item>
                                                           <b-list-group-item class="consultation-item__body"> {{ $t('message.taSystoliqueD') }} : {{ parameter.taSystoliqueD }} </b-list-group-item>
                                                            <b-list-group-item class="consultation-item__body"> {{ $t('message.taDiastoliqueD') }} :{{ parameter.taDiastoliqueD }} </b-list-group-item>
                                                            <b-list-group-item class="consultation-item__body"> {{ $t('message.temperature') }}  :{{ parameter.temperature }} </b-list-group-item>
                                                            <b-list-group-item class="consultation-item__body">  {{ $t('message.heartRate') }}  :{{ parameter.frequence_cardiaque }} </b-list-group-item>
                                                            <b-list-group-item class="consultation-item__body">  {{ $t('message.respiratoryRate') }}  : {{ parameter.frequence_respiratoire }} </b-list-group-item>
                                                            <b-list-group-item class="consultation-item__body">  {{ $t('message.sato2') }}  : {{ parameter.sato2 }} </b-list-group-item>
                                                        </b-list-group>


                                                    </div>
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <!--                                    Examen cardio-->
                                    <b-row>
                                        <b-col col sm="12" class="mb-3">

                                            <h4 class="consultation-item__title">{{ $t('message.cardiacExam') }} </h4>

                                            <div  v-if="examens">
                                                    <b-list-group>
                                                        <b-list-group-item v-for="examen in examens" :key="examen.slug" class="d-flex justify-content-between align-items-center">
                                                            <b-badge variant="primary" pill class="consultation-item__body">{{examen.nom}}</b-badge>
                                                            <p class="consultation-item__body">{{examen.description}} </p>
                                                        </b-list-group-item>
                                                    </b-list-group>
                                            </div>

                                        </b-col>
                                    </b-row>


                                    <!--                                    //Diagnostic-->
                                    <b-row class="mb-3">
                                        <b-col col sm="12">
                                            <div>
                                                <h4 class="consultation-item__title">{{$t('message.conclusion')}} </h4>
                                                <p class="consultation-item__body" v-html="mConsultation.conclusion">  </p>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <!--                        Conduite à tenir-->
                                    <b-row>
                                        <b-col col sm="12">
                                            <div class="">
                                                <h4 class="consultation-item__title"> {{ $t('message.suggestTreatment') }} </h4>
                                                <p class="consultation-item__body" v-html="mConsultation.conduite_a_tenir"> </p>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <!--                                    Rendez vous-->
                                    <b-row>
<!--                                        <b-col col sm="12" class="mb-3">-->
<!--                                            <div class="">-->
<!--                                                <h4>{{ $tc('message.appointments',1) }} </h4>-->

<!--                                                <p> {{ formattedDate(mConsultation.rendez_vous) }} </p>-->

<!--                                            </div>-->
<!--                                        </b-col>-->
                                        <b-col col sm="12" v-if="mConsultation.rdv">
                                            <div class="">
                                                <h4 class="consultation-item__title">{{ $t('message.appointmentDate') }} </h4>

                                                <p class="consultation-item__body" v-html="mConsultation.rdv.date"></p>

                                            </div>
                                        </b-col>
                                        <b-col col sm="12" v-if="mConsultation.rdv">
                                            <div class="">
                                                <h4 class="consultation-item__title">{{ $t('message.appointmentReason') }} </h4>

                                                <p class="consultation-item__body" v-html="mConsultation.rdv.motifs"></p>

                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>

                            </b-col>
                            <b-col col sm="4">
                                <b-row class="justify-content-sm-center">

                                    <div class="card-footer text-right">
                                        <div v-if="!hasGestionnaireRole" @click="ImprimerConsultation" class="custom-print-wrapper">
                                            <button class="custom-print-button">
                                                <span class="custom-print-icon"></span>
                                            </button>
                                            <p class="custom-print-label">
                                                {{ $t('message.print') }}  {{ $tc('message.consultations', 1) }}
                                            </p>
                                        </div>
                                        <br>
                                        <br>
                                        <b-button variant="primary" @click="updateConsultation" v-if="canUpdate">
                                            {{ $t('message.edit') }}
                                        </b-button>
                                        <br>
                                        <br>

                                        <b-button variant="success" @click="archieveConsultation" v-if="!isTransmitted(mConsultation.passed_at) && isArchived(mConsultation.archieved_at) && (hasMedecinControleRole || hasAdminRole || hasAssistante)" >
                                            {{ $t('message.archieve') }}
                                        </b-button>
                                        <br>
                                        <b-button variant="info" @click="transmitConsultation" v-if="isTransmitted(mConsultation.passed_at) && mConsultation.isAuthor && (hasPraticienRole || hasAdminRole || hasMedecinControleRole || hasAssistante)">
                                            {{ $t('message.transmit') }}
                                        </b-button>
                                        <br>
                                        <br>

                                        <b-button variant="info" @click="reactiveConsultation" v-if="canReactive">
                                            {{ $t('message.reavivate') }} {{$tc('message.consultations',1) }}
                                        </b-button>
                                        <br>
                                        <br>

                                        <b-button v-b-modal.delete-modal variant="danger" v-if="canDelete">
                                            {{ $t('message.delete') }}
                                        </b-button>
                                        <br>
                                        <p v-if="errorshasField('nonTransmis')" style="color:red"  class="justify-content-sm-center">
                                            {{getErrorsField('nonTransmis')}}
                                        </p>
                                    </div>
                                </b-row>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col col sm="12">
                                <div v-if="files.length>0">
                                    <h4>Fichier joint </h4>
                                    <div  v-for="file in files" :key="file.id">
                                        <b-row>
                                            <b-col col sm="6">
                                                <p class="mb-3"> {{file.nom}}</p>
                                            </b-col>
                                            <b-col col sm="6">
                                                <button type="button" class=" ml-5 btn btn-success btn-sm" @click="openFile(file)">Afficher</button>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-tab>

                    <b-tab no-body :title="$tc('message.reasons',1)">
                        <div class="list-group list-group-flush" id="motifs">
                            <b-link class="ml-4"
                                    @click="toAddReason"
                                    variant="primary"
                                    v-if="(hasAdminRole) || ((hasPraticienRole || hasMedecinControleRole || hasAssistante) && isAuthor)"
                            >
                                <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.reasons',1) }}
                            </b-link>

                            <b-card-body>
                                <vue-good-table
                                        v-if="reasonsRows"
                                        :columns="reasonsColumns"
                                        :rows="reasonsRows"
                                        :search-options="enabled"
                                        :pagination-options="paginationOptions"
                                        @on-row-click="reasonsRowClick"

                                />
                            </b-card-body>
                        </div>

                    </b-tab>
                    <b-tab no-body :title=" $t('message.parameter')" :active="pathHas('parametreCommun')">
                        <b-col sm="12">
                            <div class="list-group list-group-flush" id="parametreCommun">
                                <b-link class="ml-4"
                                        @click="toAddCommonParameter"
                                        variant="primary"
                                        v-if="(hasAdminRole) || ( (hasPraticienRole || hasMedecinControleRole || hasAssistante) && commonParametersRows.length==0 && isAuthor)"
                                >
                                    <i class="fas fa-plus-circle edit-icon"></i> {{ $t('message.parameter') }}
                                </b-link>

                                <b-card-body>
                                    <vue-good-table
                                            v-if="commonParametersRows"
                                            :columns="commonParametersColumns"
                                            :rows="commonParametersRows"
                                            :search-options="enabled"
                                            :pagination-options="paginationOptions"
                                            @on-row-click="commonParametersRowClick"

                                    />
                                </b-card-body>
                            </div>
                        </b-col>
                    </b-tab>
                    <b-tab no-body :title="$t('message.currentTreatments')" :active="pathHas('traitement')">
                        <b-col sm="12">
                            <div class="list-group list-group-flush" id="traitement">
                                <b-link class="ml-4"
                                        @click="toCurrentTraitement"
                                        variant="primary"
                                        v-if="(hasAdminRole) || ((hasPraticienRole || hasMedecinControleRole || hasAssistante) && isAuthor)"
                                >
                                    <i class="fas fa-plus-circle edit-icon"></i> {{ $t('message.currentTreatments') }}
                                </b-link>

                                <b-card-body>
                                    <vue-good-table
                                            v-if="traitementsRows"
                                            :columns="traitementsColumns"
                                            :rows="traitementsRows"
                                            :search-options="enabled"
                                            :pagination-options="paginationOptions"
                                            @on-row-click="onTraitementRowClick"

                                    />
                                </b-card-body>
                            </div>
                        </b-col>
                    </b-tab>
                    <b-tab no-body :title="$t('message.infoAllergies')">
                        <b-col sm="12">
                            <div class="list-group list-group-flush" id="allergie">
                                <b-link class="ml-4"
                                        variant="primary"
                                        @click="toAllergie"
                                        v-if="hasAdminRole || hasPraticienRole || hasMedecinControleRole || hasAssistante">
                                    <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.allergies', 1) }}
                                </b-link>

                                <b-card-body>
                                    <vue-good-table
                                            v-if="notEmpty(allergiesRows)"
                                            :columns="allergiesColumns"
                                            :rows="allergiesRows"
                                            :search-options="enabled"
                                            :pagination-options="paginationOptions"
                                            @on-row-click="onAllergieRowClick"
                                    />
                                </b-card-body>
                            </div>
                        </b-col>
                    </b-tab>
                    <b-tab no-body :title="$t('message.infoAntecedents')">
                        <b-col sm="12">
                            <div class="list-group list-group-flush" id="antecedent">
                                <b-link class="ml-4" variant="primary"
                                        @click="toAntecedent"
                                        v-if="hasAdminRole || hasPraticienRole || hasMedecinControleRole || hasAssistante"
                                >
                                    <i class="fas fa-plus-circle edit-icon"></i>  {{ $t('message.add') }} {{ $tc('message.antecedents', 1) }}
                                </b-link>

                                <b-card-body>
                                    <vue-good-table
                                            v-if="notEmpty(antecedentsRows)"
                                            :columns="antecedentsColumns"
                                            :rows="antecedentsRows"
                                            :search-options="enabled"
                                            :pagination-options="paginationOptions"
                                            :groupOptions="enabled"
                                            :sort-options="sort"
                                            @on-row-click="onAntecedentRowClick"

                                    />
                                </b-card-body>
                            </div>
                        </b-col>
                    </b-tab>
                    <b-tab no-body :title="$t('message.cardiacExam')">
                        <b-col sm="12">
                            <div class="list-group list-group-flush" id="cardiacExam">
                                <b-link class="ml-4" variant="primary"
                                        @click="toCardioExam"
                                        v-if="hasAdminRole || hasPraticienRole || hasMedecinControleRole || hasAssistante"
                                >
                                    <i class="fas fa-plus-circle edit-icon"></i>{{ $t('message.cardiacExam') }}
                                </b-link>

                                <b-card-body>
                                    <vue-good-table
                                            v-if="notEmpty(examens)"
                                            :columns="cardiacExamsColumns"
                                            :rows="examens"
                                            :search-options="enabled"
                                            :pagination-options="paginationOptions"
                                            :sort-options="sort"
                                            @on-row-click="onCardioExamRowClick"

                                    />
                                </b-card-body>
                            </div>
                        </b-col>
                    </b-tab>
                </b-tabs>
                <div class="card">
                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.cardiologyConsultations', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} cardio {{ formattedDate(mConsultation.date_consultation) }}</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteConsultation" >
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import AppConfig from "../../../constants/AppConfig";
    import moment from "moment";
    import $ from "jquery";

    export default {
        name: "Cardiology",

        computed: {
            ...mapGetters(["cardiologyConsultation",
                'errors',
                'hasAdminRole',
                'hasMedecinControleRole',
                'hasAssistante',
                "hasSouscripteurRole",
                "hasPatientRole",
                'hasPraticienRole',
                'hasGestionnaireRole']),

            image: function() {
                if (!_.isUndefined(this.mConsultation.file) && !_.isNull(this.mConsultation.file)){
                    if (this.mConsultation.file.length >0 && this.mConsultation.file != 'null'){
                        return AppConfig.imgUrl + '/public/storage/' + this.mConsultation.file;
                    }
                    return "";
                }
                return "";
            },

            mConsultation: function() {
                return this.cardiologyConsultation;
            },

            praticien:function(){
                let author = this.mConsultation.author;
                if (!_.isNull(author)){
                    if (author.hasOwnProperty('user')){
                        let user = author.user
                        if (!_.isUndefined(user) && !_.isNull(user)) {
                            let prenom = (user.prenom == null) ? '' : user.prenom;
                            return (user.nom).toUpperCase() + " " +prenom.charAt(0).toUpperCase() + prenom.substring(1);
                        }
                    }else{
                        if (!_.isUndefined(author) && !_.isNull(author)) {
                            let prenom = (author.prenom == null) ? '' : author.prenom;
                            return (author.nom).toUpperCase() + " " +prenom.charAt(0).toUpperCase() + prenom.substring(1);
                        }
                    }
                }
                return  "";
            },

            examens:function(){
                let eArray = [];
                _.forEach(this.mConsultation.examen_cardios,function (examen) {
                    eArray.push({nom:examen.nom,description:examen.description,date:examen.date_examen,slug:examen.slug,id:examen.id});
                });
                return eArray;
            },

            contributeurs:function(){
                let cArray = [];
                if (!_.isUndefined(this.cardiologyConsultation.operationables)){
                    _.forEach(this.cardiologyConsultation.operationables,function (operation) {
                        if (!_.isUndefined(operation.contributable)){
                            let contributable = operation.contributable;
                            let prenom = contributable.prenom != 'null' ? contributable.prenom : '';
                            prenom =  prenom.toLowerCase();
                            let nomComplet = (contributable.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                            cArray.push({nom:nomComplet})  ;
                        }
                    });
                }
                return cArray;
            },

            files:function(){
                return _.isUndefined(this.mConsultation.files) ? [] :this.mConsultation.files;
            },

            isAuthor:function(){
                return this.mConsultation.isAuthor;
            },

            canUpdate:function(){
                return this.mConsultation.canUpdate;
            },

            canReactive:function(){
                return !_.isNull(this.mConsultation.passed_at) && (this.hasAdminRole || this.hasMedecinControleRole || this.hasAssistante);
            },

            canDelete:function(){
                if (this.hasAdminRole)
                    return true;

                return this.mConsultation.canUpdate && _.isNull(this.mConsultation.archieved_at) && _.isNull(this.mConsultation.passed_at);
            },

            etablissement:function(){
                if (!_.isUndefined(this.mConsultation.etablissement)){
                    if (!_.isNull(this.mConsultation.etablissement)){
                        return this.mConsultation.etablissement.name;
                    }
                    return "";
                }
                return  "";
            },

            nom: function() {
                if (typeof(this.cardiologyConsultation.dossier) =='object'){
                    let user = this.cardiologyConsultation.dossier.patient.user;

                    let nom = user.nom;
                    let prenom = user.prenom != null ? user.prenom : '';

                    return  prenom +" "+ nom.toUpperCase();
                }else{
                    return "";
                }
            },

            reasons:function(){
                let motifs ="";
                if(!_.isUndefined(this.mConsultation.motifs)){
                    let self = this;
                    _.forEach(this.mConsultation.motifs,function (motif,key) {
                        motifs = motifs + ((key != self.mConsultation.motifs.length && key != 0) ? "," : " ") + motif.description;
                    });

                    return motifs +" .";
                }
                return motifs + " .";
            },

            allergiesRows:function(){
                let aArray = [];
                if(!_.isUndefined(this.mConsultation.dossier)) {
                    _.forEach(this.mConsultation.dossier.allergies, function (allergy) {
                        aArray.push({description: allergy.description, date: allergy.date, slug: allergy.slug})
                    })
                }
                return aArray;
            },

            commonParametersRows:function(){
                let cArray = [];
                if(!_.isUndefined(this.mConsultation.parametres_commun)) {
                    _.forEach(this.mConsultation.parametres_commun, function (parametre_commun) {
                        cArray.push({
                            taSystoliqueL:parametre_commun.ta_systolique,
                            taDiastoliqueL:parametre_commun.ta_diastolique,
                            taSystoliqueD:parametre_commun.ta_systolique_d,
                            taDiastoliqueD:parametre_commun.ta_diastolique_d,
                            poids:parametre_commun.poids,
                            taille:parametre_commun.taille,
                            temperature:parametre_commun.temperature,
                            bmi:parametre_commun.bmi,
                            frequence_respiratoire:parametre_commun.frequence_respiratoire,
                            frequence_cardiaque:parametre_commun.frequence_cardiaque,
                            sato2:parametre_commun.sato2,
                            slug:parametre_commun.slug,
                            perimetre_abdominal:parametre_commun.perimetre_abdominal,
                        });
                    });
                }
                return cArray;
            },

            antecedentsRows:function(){
                if(!_.isUndefined(this.mConsultation.dossier)) {
                    return _.chain(this.mConsultation.dossier.antecedents)
                        .groupBy("type")
                        .map((value, key) => ({ mode: "span", label: key, html:false, children: value }))
                        .value();
                }
                return [];
            },

            traitementsRows:function(){
                let tArray = [];
                if(!_.isUndefined(this.mConsultation.dossier)) {
                    _.forEach(this.mConsultation.dossier.traitements, function (traitement) {
                        tArray.push({description: traitement.description,slug:traitement.slug})
                        // tArray.push({date:traitement.created_at,description: traitement.description,slug:traitement.slug})
                    });
                }
                return tArray;
            },

            // conclusionsRows:function () {
            //     let cArray = [];
            //     if(!_.isUndefined(this.mConsultation.conclusions)) {
            //         _.forEach(this.mConsultation.conclusions, function (conclusion) {
            //             cArray.push({reference:conclusion.reference,description: conclusion.description,slug:conclusion.slug})
            //         });
            //     }
            //     return cArray;
            // },

            reasonsRows:function(){
                let mArray = [];
                if(!_.isUndefined(this.mConsultation.motifs)) {
                    _.forEach(this.mConsultation.motifs, function (motif) {
                        mArray.push({reference:motif.reference,description: motif.description,slug:motif.slug})
                    });
                }
                return mArray;
            },

            lastTraitment:function () {
                if (this.traitementsRows.length > 0){
                    if (!_.isUndefined(this.traitementsRows[(this.traitementsRows.length -1)])){
                        return (this.traitementsRows[(this.traitementsRows.length -1)]).description;
                    }
                    return "";
                }
                return "";
            }


        },

        data() {
            return {
                afficher : 0,

                consultation_id: this.$route.params.consultation,

                cardiacExamsColumns: [
                    {
                        label: this.$i18n.t('message.name'),
                        field: 'nom',
                    },
                    {
                        label: 'Description',
                        field: 'description',
                    },
                    {
                        label: this.$i18n.t('message.date'),
                        field: 'date',
                        type: 'date',
                        dateInputFormat: 'yyyy-MM-dd',
                        dateOutputFormat: 'dd/MM/yyyy',
                    },
                ],


                commonParametersColumns:[
                    {
                        label: this.$i18n.t('message.weight'),
                        field: 'poids',
                    },

                    {
                        label:  this.$i18n.t('message.height'),
                        field: 'taille',
                    },

                    {
                        label:  this.$i18n.t('message.bmi'),
                        field: 'bmi',
                    },


                    {
                        label:  this.$i18n.t('message.taSystoliqueL'),
                        field: 'taSystoliqueL',
                    },

                    {
                        label:  this.$i18n.t('message.taDiastoliqueL'),
                        field: 'taDiastoliqueL',
                    },
                    {
                        label:  this.$i18n.t('message.taSystoliqueD'),
                        field: 'taSystoliqueD',
                    },

                    {
                        label:  this.$i18n.t('message.taDiastoliqueD'),
                        field: 'taDiastoliqueD',
                    },

                    {
                        label: this.$i18n.t('message.temperature'),
                        field: 'temperature',
                    },



                    {
                        label: this.$i18n.t('message.heartRate'),
                        field: 'frequence_cardiaque',
                    },

                    {
                        label: this.$i18n.t('message.respiratoryRate'),
                        field: 'frequence_respiratoire',
                    },

                ],

                traitementsColumns:[
                    {
                        label: 'Description',
                        field: 'description',
                        html: true,
                    },
                    // {
                    //     label: this.$i18n.t('message.prescriptionDate'),
                    //     field: 'date',
                    //     type: 'date',
                    //     dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
                    //     dateOutputFormat: 'dd/MM/yyyy',
                    // },
                ],

                reasonsColumns:[
                    {
                        label: this.$i18n.t('message.reference'),
                        field: 'reference',
                    },
                    {
                        label: this.$i18n.t('message.description'),
                        field: 'description',
                        html: true,
                    },
                ],

                conclusionsColumns:[
                    {
                        label: this.$i18n.t('message.reference'),
                        field: 'reference',
                    },
                    {
                        label: this.$i18n.t('message.description'),
                        field: 'description',
                        html: true,
                    },
                ],

                antecedentsColumns:[
                    {
                        label: this.$i18n.tc('message.types',1),
                        field: 'type',
                    },
                    {
                        label: 'Description',
                        field: 'description',
                        html: true,
                    },
                    {
                        label: this.$i18n.t('message.startDate'),
                        field: 'date',
                        type: 'date',
                        dateInputFormat: 'yyyy-MM-dd',
                        dateOutputFormat: 'dd/MM/yyyy',
                    },
                ],

                paginationOptions:{
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },

                enabled:{enabled: true},

                sort:{
                    enabled: true,
                    initialSortBy: {field: 'date', type: 'desc'}
                },

                allergiesColumns: [
                    {
                        label: 'Description',
                        field: 'description',
                        html: true,
                    },
                    // {
                    //     label: this.$i18n.t('message.startDate'),
                    //     field: 'date',
                    //     type: 'date',
                    //     dateInputFormat: 'yyyy-MM-dd',
                    //     dateOutputFormat: 'dd/MM/yyyy',
                    // },
                ],
            }
        },

        methods: {
            onCardioExamRowClick(params){
                this.$router.push({name: 'cardiology-exam', params: {cardiology: params.row.slug}});
            },

            toCardioExam(){
                this.$router.push({name: 'add-cardiology-exam', params: {cardiology: this.consultation_id}});

            },

            openFile(file){
                window.open(AppConfig.imgUrl + '/public/storage/' + file.chemin);
            },

            ImprimerConsultation(){
                let args = {
                    cardiologie: this.consultation_id
                };

                this.$store.dispatch("printConsultationCardiologie", { args });
            },

            reasonsRowClick(params){
                this.$router.push({ name: 'reason', params: { reason: params.row.slug } });

            },

            allerA(item){
                return this.$route.path + item;
            },

            // conclusionsRowClick(params){
            //     this.$router.push({ name: 'conclusion', params: { conclusion: params.row.slug } });
            // },

            commonParametersRowClick(params){
                this.$router.push({ name: 'parameter-common', params: { parameter: params.row.slug } });
            },

            onTraitementRowClick(params){
                this.$router.push({ name: 'treatment', params: { treatment: params.row.slug } });
            },

            onAntecedentRowClick(params){
                this.$router.push({ name: 'antecedent', params: { antecedent: params.row.slug, file: this.cardiologyConsultation.dossier.slug } });
            },

            onAllergieRowClick(params){
                this.$router.push({ name: 'allergy', params: { allergy: params.row.slug } });
            },

            notEmpty(item){
                return item.length > 0;
            },

            toAllergie(){
                this.$router.push({ name: 'add-allergy', params: { file: this.cardiologyConsultation.dossier.slug } })
            },

            toCurrentTraitement(){
                this.$router.push({ name: 'add-treatments', params: { file: this.cardiologyConsultation.dossier.slug } })
            },

            toAddReason() {
                this.$router.push({ name: 'add-consultation-reason', params: { consultation: this.consultation_id } })
            },

            toAddCommonParameter(){
                this.$router.push({name: 'add-parameter-common',params:{ consultation: this.consultation_id}})
            },

            toConclusion(){
                this.$router.push( { name: 'conclusions', params: { consultation: this.consultation_id } })
            },

            toAntecedent(){
                this.$router.push( { name: 'add-antecedent', params: { file: this.cardiologyConsultation.dossier.slug }})
            },

            getConsultation() {
                let args = {
                    consultation: this.consultation_id
                };

                this.$store.dispatch("getCardiologyConsultation", { args });
            },

            formattedDate(date) {
                return !_.isNull(date) ? moment(date).format('DD-MM-YYYY') : "";
            },

            updateConsultation() {
                this.$router.push({ name: 'edit-consultation-cardiology', params: { consultation: this.consultation_id } });
            },

            deleteConsultation() {
                let self = this;
                let args = {
                    consultation: this.consultation_id
                };

                let successMessage = this.$i18n.t('message.cardiologyConsultationsDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteCardiologyConsultation', { args, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();

                });
            },

            archieveConsultation(){
                let self = this;
                let args = {
                    consultation: this.consultation_id
                };

                let successMessage = this.$i18n.t('message.cardiologyConsultationArchieved');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('archieveCardiologyConsultation', { args, successMessage, errorMessages });

            },

            transmitConsultation(){
                let self = this;
                let args = {
                    consultation: this.consultation_id
                };

                let successMessage = this.$i18n.t('message.cardiologyConsultationTransmitted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('transmitCardiologyConsultation', { args, index: self.consultation_id, successMessage, errorMessages });

            },

            reactiveConsultation(){
                let self = this;
                let args = {
                    consultation: this.consultation_id
                };

                let successMessage = this.$i18n.t('message.cardiologyConsultationReactived');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('reactiveCardiologyConsultation', { args, index: self.consultation_id, successMessage, errorMessages });

            },

            isArchived:function(date){
                let momentDate = moment(date);
                return !momentDate.isValid() ;
            },

            isTransmitted:function(date){
                var momentDate = moment(date);
                return !momentDate.isValid() ;
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },
            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },
            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            },
            pathHas(element){
                let result = (this.$route.fullPath).includes(element);
                if(result){
                    if ($('#'+element).length){
                        document.getElementById(element).scrollIntoView(top);
                    }
                }

                return result;
            }
        },

        mounted() {
            this.getConsultation();
        }
    }
</script>

<style scoped>

</style>